// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-E":"SHP2E_shp2-detail-E__xS_We"};